import { JsonInputType } from "@tosize/shapes/src/lib/models/Input/JsonInputType";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { z } from "zod";
import { useErrorContext } from "../context/ErrorContext";
import useProducts from "./useProducts";

const useAgreement = () => {
	const intl = useIntl();
	const { setErrors, errorMap, setTouchedFields } = useErrorContext();
	const { productData } = useProducts();

	const schema = z.boolean().refine((val) => val === true, {
		message: intl.formatMessage({ defaultMessage: "Ga akkoord met de voorwaarden" }),
	});

	const validate = useCallback(
		async (value: boolean) => {
			if (productData?.agreement?.mandatory) {
				const result = await schema.safeParseAsync(value, { errorMap });

				setErrors((prev) => ({
					...prev,
					accepted_condition: result.success === false ? result.error.issues : [],
				}));

				setTouchedFields((prev) => ({
					...prev,
					accepted_condition: [JsonInputType.Agreement],
				}));

				return result.success;
			}

			return true;
		},
		[errorMap, productData?.agreement?.mandatory, schema, setErrors, setTouchedFields],
	);

	return {
		validate,
		schema,
	};
};

export default useAgreement;
